var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRainbowBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 3414,
    viewBox: "0 0 1440 3414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7895_12871)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18.2434 1777.63C230.179 2004.66 643.061 2565.8 307.211 2994.14C-112.601 3529.56 -227.75 3477.54 -18.2434 1777.63Z",
    fill: "#96F7FD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1166.22 2560.48C1119.55 2607.15 2.08087 2971.58 166.335 3572.09C330.589 4172.59 672.561 3708.52 1166.22 2560.48Z",
    fill: "#FBD3FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.089 3185.17C138.897 3131.17 -31.6456 3066.01 15.7236 3237.29C74.9352 3451.41 470.098 3313.1 230.089 3185.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-402.558 3189.06C-303.1 3049.2 -50.0548 2881.03 166.457 3327.29C437.098 3885.12 -640.095 4072.56 -402.558 3189.06Z",
    fill: "#A6CDFF"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 3010.5,
    r: 403.5,
    fill: "url(#paint0_radial_7895_12871)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7895_12871)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519.25 3044.21C1305.92 2849.25 951.367 2367.38 1239.77 1999.55C1600.28 1539.76 1699.16 1584.43 1519.25 3044.21Z",
    fill: "#96F7FD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.11 2371.95C542.19 2331.87 1501.8 2018.92 1360.75 1503.25C1219.7 987.572 926.034 1386.08 502.11 2371.95Z",
    fill: "#FBD3FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1306 1835.51C1384.31 1881.87 1530.76 1937.83 1490.08 1790.74C1439.24 1606.88 1099.9 1725.65 1306 1835.51Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1849.28 1832.16C1763.87 1952.27 1546.57 2096.68 1360.64 1713.46C1128.24 1234.43 2053.26 1073.47 1849.28 1832.16Z",
    fill: "#A6CDFF"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 1379.5,
    cy: 1985.5,
    r: 346.5,
    transform: "rotate(-180 1379.5 1985.5)",
    fill: "url(#paint1_radial_7895_12871)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7895_12871)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1726,
    y: -87.9999,
    width: 935,
    height: 935,
    rx: 454.767,
    transform: "rotate(90 1726 -87.9999)",
    fill: "#F7FBFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1255.82 543.536C1760.48 256.443 1951.97 778.168 2004.45 830.628C2544.3 456.486 2004.45 -465.324 1464.6 -282.577C924.758 -99.8289 751.154 830.628 1255.82 543.536Z",
    fill: "#D9FDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1461.46 364.097C1859.38 137.624 2010.36 549.187 2051.75 590.571C2477.41 295.428 2051.75 -431.744 1626.09 -287.583C1200.42 -143.422 1063.54 590.571 1461.46 364.097Z",
    fill: "#6DB3F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.697 -153.534C970.476 -80.0134 1000.01 89.6751 751.885 180.265C441.734 293.502 638.648 -487.333 924.697 -153.534Z",
    fill: "#FACFE9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_7895_12871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1105.7 927.13C1082.05 909.395 1034.3 611.522 724.15 665.185C413.999 718.847 909.695 1134.96 1105.7 927.13Z",
    fill: "#C5ABF2"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1258.5,
    cy: 379.5,
    rx: 476.5,
    ry: 476.5,
    transform: "rotate(90 1258.5 379.5)",
    fill: "url(#paint2_radial_7895_12871)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7895_12871",
    x: -326.1,
    y: 1571.86,
    width: 965.359,
    height: 1928.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 102.888,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7895_12871",
    x: 3.13992,
    y: 2413.75,
    width: 1309.81,
    height: 1568.37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 73.3636,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7895_12871",
    x: -135.58,
    y: 2983.53,
    width: 585.44,
    height: 508.245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 71.5743,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_7895_12871",
    x: -589.136,
    y: 2886.14,
    width: 951.646,
    height: 1064.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.0477,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_7895_12871",
    x: 954.634,
    y: 1564.48,
    width: 828.987,
    height: 1656.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 88.3537,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_7895_12871",
    x: 376.109,
    y: 1151.13,
    width: 1124.78,
    height: 1346.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_7895_12871",
    x: 1117.28,
    y: 1572.21,
    width: 502.736,
    height: 436.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 61.4634,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_7895_12871",
    x: 1192.29,
    y: 1177.92,
    width: 817.214,
    height: 914.372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.3049,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_7895_12871",
    x: 552.702,
    y: -709.211,
    width: 2078.28,
    height: 1942.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 201.462,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_7895_12871",
    x: 957.361,
    y: -573.691,
    width: 1538.1,
    height: 1431.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 133.701,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_7895_12871",
    x: 501.796,
    y: -329.936,
    width: 546.601,
    height: 614.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46.3862,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_7895_12871",
    x: 414.474,
    y: 448.625,
    width: 901.327,
    height: 746.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 105.051,
    result: "effect1_foregroundBlur_7895_12871"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7895_12871",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.5 3010.5) rotate(90) scale(403.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64355,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7895_12871",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1379.5 1985.5) rotate(90) scale(346.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64355,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7895_12871",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1258.5 379.5) rotate(90) scale(476.5 476.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64355,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7895_12871"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -236.633,
    y: 2629.37,
    width: 778.37,
    height: 778.37,
    rx: 389.185,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7895_12871"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1706.79,
    y: 2312.79,
    width: 668.415,
    height: 668.415,
    rx: 334.207,
    transform: "rotate(-180 1706.79 2312.79)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7895_12871"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1726,
    y: -87.9999,
    width: 935,
    height: 935,
    rx: 454.767,
    transform: "rotate(90 1726 -87.9999)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbowBackground);
export default __webpack_public_path__ + "static/media/rainbow-background.1eb7f011aa3fe451469460ed1325406c.svg";
export { ForwardRef as ReactComponent };